import { render, staticRenderFns } from "./StartWaterTest.vue?vue&type=template&id=cf60ce70&scoped=true&"
import script from "./StartWaterTest.vue?vue&type=script&lang=js&"
export * from "./StartWaterTest.vue?vue&type=script&lang=js&"
import style0 from "./StartWaterTest.vue?vue&type=style&index=0&id=cf60ce70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf60ce70",
  null
  
)

export default component.exports